export default __webpack_public_path__ + "1d6685bd6b5b21ec72c955a3fde1df7a.svg";